import styled from '@emotion/styled/macro';
import { TableWrapper } from '../../../common/SideBySideTableLayout/SideBySideTableLayout.styles';
import rem from '../../../utils/rem/rem';

export const H1 = styled.h1`
  font-family: 'Pizza Hut';
  font-size: ${rem(30)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray800};
`;

export const StyledTableWrapper = styled(TableWrapper)`
  height: 60vh;
`;

export const SelectRawProdsContainer = styled.div`
  margin: 0 32px;

  h2 {
    margin-top: ${rem(12)};
    margin-bottom: ${rem(30)};
  }
`;

export const InputButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: ${rem(2)};

  input {
    margin-bottom: ${rem(0)};
    width: ${rem(285)};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: ${rem(30)};
`;
